import { render, staticRenderFns } from "./FloatingActionButton.vue?vue&type=template&id=23f1f4ce&scoped=true&"
import script from "./FloatingActionButton.vue?vue&type=script&lang=js&"
export * from "./FloatingActionButton.vue?vue&type=script&lang=js&"
import style0 from "./FloatingActionButton.vue?vue&type=style&index=0&id=23f1f4ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f1f4ce",
  null
  
)

export default component.exports